import {useSelector} from "react-redux";
export const useHasPermission = (requiredPermission) => {
    const { user } = useSelector((state) => state.auth);

    if (user?.super_admin) {
        return true
    }

    if (user?.permissions) {
        if (Array.isArray(requiredPermission)) {
            return requiredPermission.some((perm) => user.permissions.includes(perm));
        }
    }


    if (user?.permissions) {
        return user.permissions.includes(requiredPermission);
    } else {
        return false;
    }
};